import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=31ff233e&scoped=true&"
import script from "./right-bar.vue?vue&type=script&lang=js&"
export * from "./right-bar.vue?vue&type=script&lang=js&"
import style0 from "./right-bar.vue?vue&type=style&index=0&id=31ff233e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff233e",
  null
  
)

export default component.exports